/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.Message,
        questionText: questionIds.Message,
        canBeDisabled: false
    }
];
/* eslint-enable max-len */
